import React, { Component } from 'react'
import 'react-vant/es/styles';
import './index.less'
import {
  setDocumentTitle,
  setUidToken,
  getlang,
  setlang,
  unix2date6,
  inject,
  observer
} from '../../../helper/devTools.js'

import config from 'src/core/config'
import localstorage from 'src/helper/localstorage'
import uploadImg from '../../../tools/uploadImage';
import brower from '../../../helper/brower'
import { chooseImage as handleChooseImage, uploadFile as uploadFileImg } from '../../../helper/webviewFun'
import DateTimePicker from 'react-vant/es/datetime-picker/DatetimePicker.js'
import Picker from 'react-vant/es/picker'
import { history } from 'src/core/router'
import Swiper from 'swiper';
import 'swiper/swiper-bundle.min.css';
import Message from '../../../component/Message'
import LoadingComp from '../../../component/LoadingComp'
import VConsole from '../../../helper/vconsole'

import 'rmc-picker/assets/index.css'
import 'rmc-date-picker/assets/index.css'
import 'rmc-picker/assets/popup.css'
import PopPicker from 'rmc-date-picker/lib/Popup'
import RmcDatePicker from 'rmc-date-picker/lib/DatePicker'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import { isRtl } from 'src/helper/tool'

@inject('store')
@observer

export default class extends Component {
  constructor(props) {
    super(props)
    this.partyStore = this.props.store.register('app/partyStore')
    // setDocumentTitle('Create')
  }
  state = {
    userInfo: {},
    lang: {},
    messageTxt: "",
    acTheme: "",
    acDesc: "",
    language:'en',
    // time
    minDate: 0,
    maxDate: 0,
    datePickerShow: false,
    hourPickerShow: false,
    hourValue: "",
    startDate: "",
    startDateShow: "",
    mySwiper: null,
    heddinValue:true,
    bigShowImg: "",
    imagePath: "",
    formData: null,
    imgId: "",
    imgUrl: "",
    picList: [],
    isShowSelPic: false,
    selImgList: [],
    defaultGold: 100,
    currentGold: 0,
    client: null,
    showLoding:false,
    files: null,
    datePickerLocale: {},
    startOriginDate: null
  }

  async uploadImage(files) {
    try {
      let res = await uploadImg(files)
      if (res && res.url) {
        this.setState({
          saveImgUrl: res.url,
          imgUrl: res.url
        })
      }else if (res.code == 11) {
        this.refs.msg.show(this.state.lang.errorImgUP)
      }
    } catch (error) {
      this.refs.msg.show(error)
    }
  }

  formatTxt(t, v) {
    if (t == "year") {
      t = this.state.lang.y
    }
    if (t == "month") {
      t = this.state.lang.m
    }
    if (t == "day") {
      t = this.state.lang.d
    }
    if (t == "hour") {
      t = this.state.lang.h
    }
    if (t == "minute") {
      t = this.state.lang.mi
    }
    return v + t
  }

  initTime() {
    // 获取当前时间的时间戳
    var timestamp = Date.now();
    timestamp = (timestamp - (timestamp % (60 * 1000))) + 60000
    // 创建一个新的Date对象，并设置时间戳
    var date = new Date(timestamp);
    // 设置时区偏移量（以分钟为单位）
    var timezoneOffset = 0; // 例如，中国标准时间（CST）为UTC+8，所以偏移量为8小时，即8 * 60 = 480分钟
    // 根据时区偏移量调整时间
    date.setMinutes(date.getMinutes() + timezoneOffset);


    // 10天
    var currentDate = new Date();
    var tenDaysAgo = new Date(currentDate.setDate(currentDate.getDate() + 10));
    var tenDaysAgoTimestamp = tenDaysAgo.setHours(0, 0, 0, 0);

    this.setState({
      minDate: date,
      maxDate: tenDaysAgoTimestamp
    })

    // 获取调整后的时间的各个部分
    var year = date.getFullYear();
    var month = date.getMonth() + 1; // 月份从0开始，所以要加1
    var day = date.getDate();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    // 输出时间
    console.log(year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds);
  }

  getDate(timestamp) {
    // 创建一个新的Date对象，并设置时间戳
    return unix2date6(timestamp)
  }

  handleDateConfirm(value) {
    console.log(new Date(value).getTime(), '时间戳')
    console.log(Math.floor(new Date(value).getTime() / 1000), '时间戳2')
    this.setState({
      startDate: Math.floor(new Date(value).getTime() / 1000),
      datePickerShow: false,
      startDateShow: this.getDate(value),
      startOriginDate: value
    })
  }

  handleDateCancel() {
    this.setState({
      datePickerShow: false
    })
  }

  handleHourConfirm(value) {
    this.setState({
      hourValue: value,
      hourPickerShow: false
    })
  }

  handleHourCancel() {
    this.setState({
      hourPickerShow: false
    })
  }

  async initLang() {
    let { language } = this.props.location.query
    console.log(this.props.location, 'location')

    language =await getlang(language)
    this.setState({
      lang: setlang(language, this.partyStore.data.lang),
      language: language,
      datePickerLocale: this.partyStore.data.datePickerLocale[language] || this.partyStore.data.datePickerLocale['en']
    })
    console.log('language', language)
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uid')
    return uid
  }

  async getImageList() {
    let list = await this.partyStore.apiGetImageList()
    this.setState({
      selImgList: list && list.res
    })
  }

  async componentDidMount() {
    dayjs.extend(localizedFormat)
    this.initLang()
    this.initTime()
    await this.getImageList()
    let uid = await this.initUid()
    await this.RunOnStart(uid)
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.selImgList && prevState.selImgList.length > 0 && this.state.mySwiper === null) {
      const mySwiper = new Swiper('.swiper', {
        slidesPerView: 3.5,
        on: {
          slideChange: function () {}
        }
      })
      this.setState({
        mySwiper
      })
    }
  }
  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    console.log('%c [ this.partyStore ]-236', 'font-size:20px; background:pink; color:#bf2c9f;', this.partyStore)

    try {
      if (this.state.language == 'tr') {
        setDocumentTitle(this.partyStore.data.lang.tr.create || `Create`)
      } else if (this.state.language == 'ar') {
        setDocumentTitle(this.partyStore.data.lang.ar.create || `Create`)
      } else {
        setDocumentTitle('Create')
        if (config.host == 'https://api-test.thechatie.com' ) {
          new VConsole()
        }
      }
      this.setState({
        uid: uid
      })
      let getUserInfo = await this.partyStore.GetUserInfoWeb(uid)
      if (getUserInfo && getUserInfo.code == 0) {
        this.setState({
          userInfo: getUserInfo.res
        })
      }
    } catch (error) {
      console.error(error)
      this.refs.msg.show(error)
    }
  }

  setAcTheme(e) {
    this.setState({
      acTheme: e.currentTarget.value
    })
  }

  setAcDesc(e) {
    this.setState({
      acDesc: e.currentTarget.value
    })
  }

  setPic(v, id, gold) {
    this.setState({
      imgId: id,
      bigShowImg: v,
      imgUrl: v,
      currentGold: gold
    })
  }

/*   async onImgFileFn(e) {
    e.preventDefault()
    console.log(e.target.files)
    //获取图片文件，图片类型，图片大小
    const file = e.target.files[0]
    const type = file && file.type
    const size = file && file.size
    const regularType = ['image/png', 'image/jpg', 'image/jpeg']
    //图片类型限制
    if (regularType.indexOf(type.toLowerCase()) === -1) {
      alert('Only supports PNG or JPG images!')
      return false
    }
    //图片大小限制
    if (size && size > 5242880) {
      // 5 * 1024 * 1024，size的单位是字节
      alert('The image size should less than 5M!')
      return false
    }
    //图片文件转成base64格式
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onloadend = () => {
      this.setState({
        imagePath: reader.result,
        bigShowImg: reader.result
      })
    }

    this.uploadImage(e.target.files[0])
    
    const formData = new FormData();
    formData.append('file', e.target.files[0]);
    this.setState({
      formData: formData
    })
    e.target.value = '' // 清空上次图片数据，保证可以选择同一张图片

    // 判断当前是否有上传图片
    // if (formData) {
    //   const { accesstoken, uid } = localstorage.get('userInfo')
    //   const config = {
    //     headers: {
    //       'X-Uid': uid || this.state.userinfo.uid || this.props.location.query.uid,
    //       'X-Token': accesstoken || this.props.location.query.accesstoken
    //     }
    //   }
    //   await axios.post("/web/upload", formData, config)
    //     .then(res => {
    //       this.setState({
    //         saveImgUrl: res && res.res,
    //         imgUrl: res && res.res
    //       })
    //     })
    // }
  } */

  clearImg(nu, e) {
    e.stopPropagation()
    this.setState({
      formData: "",
      imagePath: "",
      bigShowImg: "",
      imgUrl: "",
      picList: []
    })
  }

  async handlePubRoom() {
    let { acTheme, acDesc, startDate, imgUrl, hourValue } = this.state
    console.log(acTheme, acDesc, startDate, imgUrl, hourValue)
    if (!(acTheme && acDesc && startDate && imgUrl && hourValue)) {
      this.refs.msg.show(this.state.lang.please)
      return
    }
    let res = await this.partyStore.apiHandlePubRoom({
      name: this.state.acTheme,
      description: this.state.acDesc,
      startTime: this.state.startDate,
      imageId: this.state.imgId ? this.state.imgId : 0,
      image: this.state.imgUrl,
      duration: this.state.hourValue
    })
    if (res && res.code != 0) {
      this.refs.msg.show(res.msg)
      return
    }
    this.refs.msg.show(this.state.lang.Suc2)
    localstorage.set('partycreate',1)
    this.setState({
      acTheme: "",
      acDesc: "",
      startDate: "",
      startDateShow: "",
      imgId: "",
      imgUrl: "",
      hourValue: "",
      isShowSelPic: false,
      bigShowImg: "",
      imagePath: "",
      formData: null,
      picList: [],
    })
    setTimeout(()=>{
      history.go(-2)
    },800)
  }

  handleUploadImg() {
    this.setState({
      currentGold: 0,
      imgUrl: this.state.saveImgUrl,
      bigShowImg: this.state.imagePath
    })
  }

  async androidUpload() {
    
    this.setState({
      imgUrl: "",
      formData: "",
      imagePath: "",
      picList: [],
      currentGold: 0,
    })

    let maxAdd = 1  // 限定最大图片
    let params = {
      count: maxAdd > 0 ? maxAdd : 0,
      sizeType: 'compressed',
      mp4Enabled: false,
      os: brower.isAndroid() ? 2 : 1
    }
    try {
      // 推入图片功能
      await handleChooseImage(params, async (pic) => {
        // 1. 如果没有选择图片，跳出
        if (pic.length <= 0) {
          return
        }
        // 2. 保存数据，并且展示图片
        let list = this.state.picList
        for (let i = 0; i < pic.length; i++) {
          list.push(pic[i])
        }
        this.setState({
          bigShowImg: list && list[0] && list[0].imageData,
          imagePath: list && list[0] && list[0].imageData,
          picList: list
        })
        let map2 = []
        list.length>0 && list.map((item, index) => {
          map2.push({
            filePath: item.path,
            fileType: item.image
          })
        })
        console.log("我是map2哈哈哈哈哈", map2)
        if (map2.length > 0) {
          await this.setState({
            showLoding:true,
          })
          console.log("进入map2")
          await uploadFileImg(map2, async (d) => {
            let list = d
            this.setState({
              imgUrl: list && list[0] ,
              saveImgUrl: list && list[0],
              showLoding:false,
            })
            console.log("我是imgUrl阿啊啊", this.state.imgUrl)
            return
          })
        }
      })
    }
    catch (error) {
      this.setState({
        showLoding:false,
      })
      console.error(error)
      this.refs.msg.show(error)
    }
  }

  inTheFocus = (vke)=>{
    this.setState({heddinValue:vke})
  }

  render() {
    const columns = [
      { text: '1', value: 1 },
      { text: '2', value: 2 },
      { text: '3', value: 3 },
    ]
    const minDate = new Date(this.state.minDate)
    const maxDate = new Date(this.state.maxDate)
    const value = new Date(this.state.startDate)
    let { heddinValue, lang, language } = this.state

    const rmcDatePicker = (
      <RmcDatePicker
        className="rmc-picker-custom"
        rootNativeProps={{'data-xx': 'yy'}}
        minDate={
          new Date(
            minDate.getFullYear(),
            minDate.getMonth(),
            minDate.getDate(),
            0,
            0,
            0
          )
        }
        maxDate={
          new Date(
            maxDate.getFullYear(),
            maxDate.getMonth(),
            maxDate.getDate(),
            maxDate.getHours(),
            maxDate.getMinutes(),
            maxDate.getSeconds()
          )
        }
        defaultDate={new Date()}
        mode={'datetime'}
        use12Hours={true}
        locale={this.state.datePickerLocale}
      />
    )
    return (
      <div className={`party-room-create-container`} style={{ direction: `${isRtl(this.state.language)? "rtl" : "ltr"}` }}>

        <Message ref="msg" />

        <div className="activity-theme">
          <div className="title">{this.state.lang.theme}</div>
          <div className="content">
            <input type="text" placeholder={this.state.lang.input} className='theme-input' value={this.state.acTheme} onChange={(e) => { this.setAcTheme(e) }} onFocus={()=>this.inTheFocus(false)} onBlur={()=>this.inTheFocus(true)} />
          </div>
        </div>
        <br />

        <div className="activity-desc">
          <div className="title">{this.state.lang.desc}</div>
          <div className="content">
            <textarea
              maxLength={100}
              type="text"
              placeholder={this.state.lang.input}
              className='desc-input'
              onFocus={()=>this.inTheFocus(false)}
              value={this.state.acDesc}
              onBlur={()=>this.inTheFocus(true)} 
              onChange={(e) => { this.setAcDesc(e) }}
            />
            <div className="limit">{this.state.acDesc.length}/100</div>
          </div>
        </div>
        <br />

        <div className="activity-time">
          <div className="title">{this.state.lang.time}</div>
          <div className="content">
            <div className="item">
              <PopPicker
                className="rmc-picker-popup-custom"
                datePicker={rmcDatePicker}
                transitionName="rmc-picker-popup-slide-fade"
                maskTransitionName="rmc-picker-popup-fade"
                title=""
                date={this.state.startOriginDate}
                dismissText={this.state.lang.no}
                okText={this.state.lang.yes}
                onDismiss={() => this.handleDateCancel()}
                onChange={(value) => this.handleDateConfirm(value)}
              >
                <p className='date-wrap'>
                  <span className='label'>
                    {this.state.lang.st}：
                    { this.state.startDateShow ? dayjs(this.state.startDateShow).format('lll') : ''}
                  </span>
                  <span className='jt'>
                    <img style={{ transform: `rotate(${isRtl(this.state.language) ? '180deg' : '0deg'})` }} src="/img/app/partyroom/create/right.png" alt="" />
                  </span>
                </p>
              </PopPicker>
            </div>
            <div className="line"></div>
            <div className="item" onClick={() => { this.setState({ hourPickerShow: true }) }}>
              <span>{this.state.lang.duration}：{this.state.hourValue}{this.state.hourValue && this.state.lang.h}</span>
              <span className='jt'>
                <img style={{ transform: `rotate(${isRtl(this.state.language) ? '180deg' : '0deg'})` }} src="/img/app/partyroom/create/right.png" alt="" />
              </span>
            </div>
          </div>
        </div>
        <div className="btn" onClick={() => { this.setState({ isShowSelPic: true}) }}>{this.state.lang.next}</div>
        <div
          className="mask"
          onClick={() => {
            this.setState({
              datePickerShow: false,
              hourPickerShow: false,
            })
          }}
          style={{ display: `${this.state.datePickerShow || this.state.hourPickerShow ? "block" : "none"}` }}></div>

        <div className="duration" style={{
          bottom: `${this.state.hourPickerShow ? "0" : "-10rem"}`
        }}>
          <Picker
            visibleItemCount={3}
            placeholder={this.state.lang.sel}
            showToolbar={false}
            onChange={(val, selectRow, index) => {
              this.setState({
                hourValue: val
              })
            }}
            value={this.state.hourValue}
            title='持续时间'
            columns={columns}
            itemHeight={"0.9rem"}
            onConfirm={(value) => this.handleHourConfirm(value)}
            onCancel={() => this.handleHourCancel()}
          />
        </div>

        <div className="time" style={{
          bottom: `${this.state.datePickerShow ? "0" : "-10rem"}`
        }}>
          <DateTimePicker
            visibleItemCount={4}
            type='datetime'
            itemHeight={"0.9rem"}
            minDate={minDate}
            maxDate={maxDate}
            value={value}
            formatter={(t, v) => this.formatTxt(t, v)}
            onConfirm={(value) => this.handleDateConfirm(value)}
            onCancel={() => this.handleDateCancel()}
            cancelButtonText={this.state.lang.no}
            confirmButtonText={this.state.lang.yes}
          // title={"开始时间"} 
          />
        </div>
        <div className="poster-container" style={{ left: `${this.state.isShowSelPic ? "0" : "100%"}` }}>
          <div className="big-pic">
            <img style={{ display: `${this.state.bigShowImg != "" ? "block" : "none"}` }} src={this.state.bigShowImg} alt="" />
            {/* <div style={{ display: `${this.state.bigShowImg == "" ? "block" : "none"}` }} className="tips">请选择图片</div> */}
          </div>
          <div className="pic-content">
            <div className="swiper">
              <div className="swiper-wrapper">
                <div className="swiper-slide">
                  <div className="pic-item add">
                    <label className='select-img-input' htmlFor="upload" onClick={() => { this.androidUpload() }}>
                    </label>
                    <div
                      className='display-img'
                      style={{ display: `${this.state.imagePath != "" ? "block" : "none"}` }}>
                      <img
                        style={{ display: `${this.state.imagePath ? "block" : "none"}` }}
                        className='del'
                        onClick={(e) => { this.clearImg(1, e) }}
                        src="/img/activity/ladies/del.png" />
                      <img
                        style={{ display: `${this.state.imagePath ? "block" : "none"}` }}
                        className='imagePath'
                        onClick={(e) => { this.handleUploadImg() }}
                        src={this.state.imagePath} />
                    </div>
                    {/* <input
                      id='upload'
                      className='upload'
                      onChange={(event) => this.androidUpload()}
                      type='file'
                      name='fileSelect'
                      accept='image/*'
                      multiple="mutiple"
                    /> */}
                  </div>
                </div>
                {
                  this.state.selImgList && this.state.selImgList.map((i, k) => {
                    return (
                      <div className="swiper-slide" key={k}>
                        <div className="pic-item" onClick={() => { this.setPic(i.image, i.imageId, i.gold) }}>
                          <img src={i.image} alt="" />
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
          <div className="btn-box">
            <div className="goback" onClick={() => { this.setState({ isShowSelPic: false }) }}>{this.state.lang.back}</div>
            <div className="publish" onClick={() => { this.handlePubRoom() }}>
              <span>{this.state.lang.publish}</span>
              &nbsp;
              {"("}
              {this.state.defaultGold + this.state.currentGold}
              <img src="/img/gold.png" alt="" />
              {")"}
            </div>
          </div>
        </div>
        <LoadingComp show={this.state.showLoding}></LoadingComp>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/partycreate/index.js